import React from 'react';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { setLoadableErrorAttributes } from '@confluence/monitoring/entry-points/error-attributes';

export function createElementWithCheckForInvalidType(
	type: string | React.ComponentType<any>,
	rest: any,
	name: string | undefined,
): React.ReactNode {
	if (
		// From https://github.com/facebook/react/blob/1324e1bb1f867e8b2108ca52a1d4e2d4ef56d2d9/packages/react-server/src/ReactFizzServer.js#L3001
		type === undefined ||
		(typeof type === 'object' && type !== null && Object.keys(type).length === 0)
	) {
		const error = new Error('Invalid placeholder type');
		setLoadableErrorAttributes(error, { name });
		getMonitoringClient().submitError(error, {
			attribution: 'backbone-loadable',
		});
	}
	return React.createElement(type, rest);
}
